import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=3e754c11&scoped=true"
var script = {}
import style0 from "./notFound.vue?vue&type=style&index=0&id=3e754c11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e754c11",
  null
  
)

export default component.exports